module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.10782/images/homepage/company-logos/engie.png"